export const languages = [
  {
    en: 'Afrikaans',
    pl: 'afrykański',
    pt: 'africâner',
    de: 'Afrikaans',
    es: 'afrikáans'
  },
  {
    en: 'Albanian',
    pl: 'albański',
    pt: 'albanês',
    de: 'Albanisch',
    es: 'albanés'
  },
  {
    en: 'Amharic',
    pl: 'amharski',
    pt: 'amárico',
    de: 'Amharisch',
    es: 'amárico'
  },
  {
    en: 'Arabic',
    pl: 'arabski',
    pt: 'árabe',
    de: 'Arabisch',
    es: 'árabe'
  },
  {
    en: 'Armenian',
    pl: 'armeński',
    pt: 'armênio',
    de: 'Armenisch',
    es: 'armenio'
  },
  {
    en: 'Assamese',
    pl: 'assamski',
    pt: 'assamês',
    de: 'Assamesisch',
    es: 'asamés'
  },
  {
    en: 'Azerbaijani',
    pl: 'azerski',
    pt: 'azerbaijano',
    de: 'Aserbaidschanisch',
    es: 'azerbaiyano'
  },
  {
    en: 'Basque',
    pl: 'baskijski',
    pt: 'basco',
    de: 'Baskisch',
    es: 'vasco'
  },
  {
    en: 'Belarusian',
    pl: 'białoruski',
    pt: 'bielorrusso',
    de: 'Weißrussisch',
    es: 'bielorruso'
  },
  {
    en: 'Bengali',
    pl: 'bengalski',
    pt: 'bengali',
    de: 'Bengalisch',
    es: 'bengalí'
  },
  {
    en: 'Bhojpuri',
    pl: 'bhojpuri',
    pt: 'bhojpuri',
    de: 'Bhojpuri',
    es: 'bhojpuri'
  },
  {
    en: 'Bosnian',
    pl: 'bośniacki',
    pt: 'bósnio',
    de: 'Bosnisch',
    es: 'bosnio'
  },
  {
    en: 'Bulgarian',
    pl: 'bułgarski',
    pt: 'búlgaro',
    de: 'Bulgarisch',
    es: 'búlgaro'
  },
  {
    en: 'Burmese',
    pl: 'birmański',
    pt: 'birmanês',
    de: 'Birmanisch',
    es: 'birmano'
  },
  {
    en: 'Cantonese',
    pl: 'kantoński',
    pt: 'cantonês',
    de: 'Kantonesisch',
    es: 'cantonés'
  },
  {
    en: 'Catalan',
    pl: 'kataloński',
    pt: 'catalão',
    de: 'Katalanisch',
    es: 'catalán'
  },
  {
    en: 'Cebuano',
    pl: 'cebuański',
    pt: 'cebuano',
    de: 'Cebuano',
    es: 'cebuano'
  },
  {
    en: 'Chewa',
    pl: 'chewa',
    pt: 'chewa',
    de: 'Chichewa',
    es: 'chichewa'
  },
  {
    en: 'Chhattisgarhi',
    pl: 'chhattisgarhi',
    pt: 'chhattisgarhi',
    es: 'chhattisgarhi',
    de: 'Chhattisgarhi'
  },
  {
    en: 'Chinese',
    pl: 'chiński',
    pt: 'chinês',
    de: 'Chinesisch',
    es: 'chino'
  },
  {
    en: 'Corsican',
    pl: 'korsykański',
    pt: 'corso',
    de: 'Korsisch',
    es: 'corso'
  },
  {
    en: 'Croatian',
    pl: 'chorwacki',
    pt: 'croata',
    de: 'Kroatisch',
    es: 'croata'
  },
  {
    en: 'Czech',
    pl: 'czeski',
    pt: 'tcheco',
    de: 'Tschechisch',
    es: 'checo'
  },
  {
    en: 'Danish',
    pl: 'duński',
    pt: 'dinamarquês',
    de: 'Dänisch',
    es: 'danés'
  },
  {
    en: 'Dari',
    pl: 'dari',
    pt: 'dari',
    de: 'Dari',
    es: 'dari'
  },
  {
    en: 'Dutch',
    pl: 'niderlandzki',
    pt: 'holandês',
    de: 'Niederländisch',
    es: 'neerlandés'
  },
  {
    en: 'Dzongkha',
    pl: 'dzongkha',
    pt: 'dzongkha',
    de: 'Dzongkha',
    es: 'dzongkha'
  },
  {
    en: 'English',
    pl: 'angielski',
    pt: 'inglês',
    de: 'Englisch',
    es: 'inglés'
  },
  {
    en: 'Esperanto',
    pl: 'esperanto',
    pt: 'esperanto',
    de: 'Esperanto',
    es: 'esperanto'
  },
  {
    en: 'Estonian',
    pl: 'estoński',
    pt: 'estoniano',
    de: 'Estnisch',
    es: 'estonio'
  },
  {
    en: 'Filipino (Tagalog)',
    pl: 'filipiński (tagalog)',
    pt: 'filipino (tagalo)',
    de: 'Filipino (Tagalog)',
    es: 'filipino (tagalo)'
  },
  {
    en: 'Finnish',
    pl: 'fiński',
    pt: 'finlandês',
    de: 'Finnisch',
    es: 'finlandés'
  },
  {
    en: 'French',
    pl: 'francuski',
    pt: 'francês',
    de: 'Französisch',
    es: 'francés'
  },
  {
    en: 'Frisian',
    pl: 'fryzyjski',
    pt: 'frísio',
    de: 'Friesisch',
    es: 'frisón'
  },
  {
    en: 'Galician',
    pl: 'galicyjski',
    pt: 'galego',
    de: 'Galicisch',
    es: 'gallego'
  },
  {
    en: 'Georgian',
    pl: 'gruziński',
    pt: 'georgiano',
    de: 'Georgisch',
    es: 'georgiano'
  },
  {
    en: 'German',
    pl: 'niemiecki',
    pt: 'alemão',
    de: 'Deutsch',
    es: 'alemán'
  },
  {
    en: 'Greek',
    pl: 'grecki',
    pt: 'grego',
    de: 'Griechisch',
    es: 'griego'
  },
  {
    en: 'Gujarati',
    pl: 'gudźaracki',
    pt: 'guzerate',
    de: 'Gujarati',
    es: 'guyaratí'
  },
  {
    en: 'Haitian Creole',
    pl: 'haitański kreolski',
    pt: 'crioulo haitiano',
    de: 'Haitianisch',
    es: 'criollo haitiano'
  },
  {
    en: 'Hausa',
    pl: 'hausa',
    pt: 'hauçá',
    de: 'Haussa',
    es: 'hausa'
  },
  {
    en: 'Hawaiian',
    pl: 'hawajski',
    pt: 'havaiano',
    de: 'Hawaiisch',
    es: 'hawaiano'
  },
  {
    en: 'Hebrew',
    pl: 'hebrajski',
    pt: 'hebraico',
    de: 'Hebräisch',
    es: 'hebreo'
  },
  {
    en: 'Hindi',
    pl: 'hindi',
    pt: 'hindi',
    de: 'Hindi',
    es: 'hindi'
  },
  {
    en: 'Hmong',
    pl: 'hmong',
    pt: 'hmong',
    de: 'Hmong',
    es: 'hmong'
  },
  {
    en: 'Hungarian',
    pl: 'węgierski',
    pt: 'húngaro',
    de: 'Ungarisch',
    es: 'húngaro'
  },
  {
    en: 'Icelandic',
    pl: 'islandzki',
    pt: 'islandês',
    de: 'Isländisch',
    es: 'islandés'
  },
  {
    en: 'Igbo',
    pl: 'igbo',
    pt: 'igbo',
    de: 'Igbo',
    es: 'igbo'
  },
  {
    en: 'Ilocano',
    pl: 'ilokano',
    pt: 'ilocano',
    de: 'Ilokano',
    es: 'ilocano'
  },
  {
    en: 'Indonesian',
    pl: 'indonezyjski',
    pt: 'indonésio',
    de: 'Indonesisch',
    es: 'indonesio'
  },
  {
    en: 'Irish',
    pl: 'irlandzki',
    pt: 'irlandês',
    de: 'Irisch',
    es: 'irlandés'
  },
  {
    en: 'Italian',
    pl: 'włoski',
    pt: 'italiano',
    de: 'Italienisch',
    es: 'italiano'
  },
  {
    en: 'Japanese',
    pl: 'japoński',
    pt: 'japonês',
    de: 'Japanisch',
    es: 'japonés'
  },
  {
    en: 'Javanese',
    pl: 'jawajski',
    pt: 'javanês',
    de: 'Javanisch',
    es: 'javanés'
  },
  {
    en: 'Kannada',
    pl: 'kannada',
    pt: 'kannada',
    de: 'Kannada',
    es: 'canarés'
  },
  {
    en: 'Kashmiri',
    pl: 'kaszmirski',
    pt: 'caxemira',
    de: 'Kaschmirisch',
    es: 'cachemir'
  },
  {
    en: 'Kazakh',
    pl: 'kazachski',
    pt: 'cazaque',
    de: 'Kasachisch',
    es: 'kazajo'
  },
  {
    en: 'Khmer',
    pl: 'khmerski',
    pt: 'khmer',
    de: 'Khmer',
    es: 'jemer'
  },
  {
    en: 'Kinyarwanda',
    pl: 'kinyarwanda',
    pt: 'kinyarwanda',
    de: 'Kinyarwanda',
    es: 'kinyarwanda'
  },
  {
    en: 'Kirundi',
    pl: 'kirundi',
    pt: 'kirundi',
    de: 'Kirundi',
    es: 'kirundi'
  },
  {
    en: 'Korean',
    pl: 'koreański',
    pt: 'coreano',
    de: 'Koreanisch',
    es: 'coreano'
  },
  {
    en: 'Kurdish',
    pl: 'kurdyjski',
    pt: 'curdo',
    de: 'Kurdisch',
    es: 'kurdo'
  },
  {
    en: 'Kyrgyz',
    pl: 'kirgiski',
    pt: 'quirguiz',
    de: 'Kirgisisch',
    es: 'kirguís'
  },
  {
    en: 'Lao',
    pl: 'laotański',
    pt: 'laosiano',
    de: 'Laotisch',
    es: 'laosiano'
  },
  {
    en: 'Latin',
    pl: 'łaciński',
    pt: 'latim',
    de: 'Latein',
    es: 'latín'
  },
  {
    en: 'Latvian',
    pl: 'łotewski',
    pt: 'letão',
    de: 'Lettisch',
    es: 'letón'
  },
  {
    en: 'Lithuanian',
    pl: 'litewski',
    pt: 'lituano',
    de: 'Litauisch',
    es: 'lituano'
  },
  {
    en: 'Luxembourgish',
    pl: 'luksemburski',
    pt: 'luxemburguês',
    de: 'Luxemburgisch',
    es: 'luxemburgués'
  },
  {
    en: 'Macedonian',
    pl: 'macedoński',
    pt: 'macedônio',
    de: 'Mazedonisch',
    es: 'macedonio'
  },
  {
    en: 'Malagasy',
    pl: 'malgaski',
    pt: 'malgaxe',
    de: 'Malagasy',
    es: 'malgache'
  },
  {
    en: 'Malay',
    pl: 'malajski',
    pt: 'malaio',
    de: 'Malaiisch',
    es: 'malayo'
  },
  {
    en: 'Malayalam',
    pl: 'malajalam',
    pt: 'malaiala',
    de: 'Malayalam',
    es: 'malayalam'
  },
  {
    en: 'Maltese',
    pl: 'maltański',
    pt: 'maltês',
    de: 'Maltesisch',
    es: 'maltés'
  },
  {
    en: 'Maori',
    pl: 'maoryski',
    pt: 'maori',
    de: 'Maori',
    es: 'maorí'
  },
  {
    en: 'Marathi',
    pl: 'marathi',
    pt: 'marati',
    de: 'Marathi',
    es: 'maratí'
  },
  {
    en: 'Mongolian',
    pl: 'mongolski',
    pt: 'mongol',
    de: 'Mongolisch',
    es: 'mongol'
  },
  {
    en: 'Nepali',
    pl: 'nepalski',
    pt: 'nepalês',
    de: 'Nepalesisch',
    es: 'nepalí'
  },
  {
    en: 'Norwegian',
    pl: 'norweski',
    pt: 'norueguês',
    de: 'Norwegisch',
    es: 'noruego'
  },
  {
    en: 'Oriya',
    pl: 'orija',
    pt: 'oriá',
    de: 'Odia',
    es: 'oriya'
  },
  {
    en: 'Oromo',
    pl: 'oromo',
    pt: 'oromo',
    de: 'Oromo',
    es: 'oromo'
  },
  {
    en: 'Pashto',
    pl: 'paszto',
    pt: 'pashto',
    de: 'Paschtu',
    es: 'pastún'
  },
  {
    en: 'Persian',
    pl: 'perski',
    pt: 'persa',
    de: 'Persisch',
    es: 'persa'
  },
  {
    en: 'Polish',
    pl: 'polski',
    pt: 'polonês',
    de: 'Polnisch',
    es: 'polaco'
  },
  {
    en: 'Portuguese',
    pl: 'portugalski',
    pt: 'português',
    de: 'Portugiesisch',
    es: 'portugués'
  },
  {
    en: 'Punjabi',
    pl: 'pendżabski',
    pt: 'punjabi',
    de: 'Panjabi',
    es: 'panyabí'
  },
  {
    en: 'Romanian',
    pl: 'rumuński',
    pt: 'romeno',
    de: 'Rumänisch',
    es: 'rumano'
  },
  {
    en: 'Russian',
    pl: 'rosyjski',
    pt: 'russo',
    de: 'Russisch',
    es: 'ruso'
  },
  {
    en: 'Samoan',
    pl: 'samoański',
    pt: 'samoano',
    de: 'Samoanisch',
    es: 'samoano'
  },
  {
    en: 'Scots Gaelic',
    pl: 'szkocki gaelicki',
    pt: 'gaélico escocês',
    de: 'Schottisch-Gälisch',
    es: 'gaélico escocés'
  },
  {
    en: 'Serbian',
    pl: 'serbski',
    pt: 'sérvio',
    de: 'Serbisch',
    es: 'serbio'
  },
  {
    en: 'Sesotho',
    pl: 'sesotho',
    pt: 'sesotho',
    de: 'Sesotho',
    es: 'sesotho'
  },
  {
    en: 'Shona',
    pl: 'shona',
    pt: 'shona',
    de: 'Shona',
    es: 'shona'
  },
  {
    en: 'Sindhi',
    pl: 'sindhi',
    pt: 'sindi',
    de: 'Sindhi',
    es: 'sindhi'
  },
  {
    en: 'Sinhala',
    pl: 'singaleski',
    pt: 'cingalês',
    de: 'Singhalesisch',
    es: 'cingalés'
  },
  {
    en: 'Slovak',
    pl: 'słowacki',
    pt: 'eslovaco',
    de: 'Slowakisch',
    es: 'eslovaco'
  },
  {
    en: 'Slovenian',
    pl: 'słoweński',
    pt: 'esloveno',
    de: 'Slowenisch',
    es: 'esloveno'
  },
  {
    en: 'Somali',
    pl: 'somalijski',
    pt: 'somali',
    de: 'Somali',
    es: 'somalí'
  },
  {
    en: 'Spanish',
    pl: 'hiszpański',
    pt: 'espanhol',
    de: 'Spanisch',
    es: 'español'
  },
  {
    en: 'Sundanese',
    pl: 'sundajski',
    pt: 'sundanês',
    de: 'Sundanesisch',
    es: 'sundanés'
  },
  {
    en: 'Swahili',
    pl: 'suahili',
    pt: 'suaíli',
    de: 'Swahili',
    es: 'suajili'
  },
  {
    en: 'Swedish',
    pl: 'szwedzki',
    pt: 'sueco',
    de: 'Schwedisch',
    es: 'sueco'
  },
  {
    en: 'Tajik',
    pl: 'tadżycki',
    pt: 'tajique',
    de: 'Tadschikisch',
    es: 'tayiko'
  },
  {
    en: 'Tamil',
    pl: 'tamilski',
    pt: 'tâmil',
    de: 'Tamil',
    es: 'tamil'
  },
  {
    en: 'Tatar',
    pl: 'tatarski',
    pt: 'tártaro',
    de: 'Tatarisch',
    es: 'tártaro'
  },
  {
    en: 'Telugu',
    pl: 'telugu',
    pt: 'telugu',
    de: 'Telugu',
    es: 'télugu'
  },
  {
    en: 'Thai',
    pl: 'tajski',
    pt: 'tailandês',
    de: 'Thailändisch',
    es: 'tailandés'
  },
  {
    en: 'Tibetan',
    pl: 'tybetański',
    pt: 'tibetano',
    de: 'Tibetisch',
    es: 'tibetano'
  },
  {
    en: 'Tigrinya',
    pl: 'tigrinia',
    pt: 'tigrínia',
    de: 'Tigrinya',
    es: 'tigrinya'
  },
  {
    en: 'Tongan',
    pl: 'tongański',
    pt: 'tonganês',
    de: 'Tonganisch',
    es: 'tongano'
  },
  {
    en: 'Turkish',
    pl: 'turecki',
    pt: 'turco',
    de: 'Türkisch',
    es: 'turco'
  },
  {
    en: 'Turkmen',
    pl: 'turkmeński',
    pt: 'turcomeno',
    de: 'Turkmenisch',
    es: 'turcomano'
  },
  {
    en: 'Ukrainian',
    pl: 'ukraiński',
    pt: 'ucraniano',
    de: 'Ukrainisch',
    es: 'ucraniano'
  },
  {
    en: 'Urdu',
    pl: 'urdu',
    pt: 'urdu',
    de: 'Urdu',
    es: 'urdu'
  },
  {
    en: 'Uyghur',
    pl: 'ujgurski',
    pt: 'uigur',
    de: 'Uigurisch',
    es: 'uigur'
  },
  {
    en: 'Uzbek',
    pl: 'uzbecki',
    pt: 'uzbeque',
    de: 'Usbekisch',
    es: 'uzbeko'
  },
  {
    en: 'Vietnamese',
    pl: 'wietnamski',
    pt: 'vietnamita',
    de: 'Vietnamesisch',
    es: 'vietnamita'
  },
  {
    en: 'Welsh',
    pl: 'walijski',
    pt: 'galês',
    de: 'Walisisch',
    es: 'galés'
  },
  {
    en: 'Wolof',
    pl: 'wolof',
    pt: 'wolof',
    de: 'Wolof',
    es: 'wolof'
  },
  {
    en: 'Xhosa',
    pl: 'xhosa',
    pt: 'xosa',
    de: 'Xhosa',
    es: 'xhosa'
  },
  {
    en: 'Yiddish',
    pl: 'jidysz',
    pt: 'iídiche',
    de: 'Jiddisch',
    es: 'yidis'
  },
  {
    en: 'Yoruba',
    pl: 'joruba',
    pt: 'iorubá',
    de: 'Yoruba',
    es: 'yoruba'
  },
  {
    en: 'Zulu',
    pl: 'zulu',
    pt: 'zulu',
    de: 'Zulu',
    es: 'zulú'
  }
]

export const languageAbbrevetions = {
  en: 'English',
  pl: 'Polish',
  pt: 'Portuguese',
  es: 'Spanish',
  de: 'German'
}
